/**
 * THE NEW CHAT SHEET'S RULES (ITP-E-203-04), after carbon's sheet (OCA-E-160, origin/main `ChatPanel.tsx` 2213-2320):
 * what Continue does with the people ticked, and the name a new group arrives with.
 */

/** Continue is disabled with nobody ticked, opens the 1:1 with one, and asks for a group's name with two or more. */
export type NewChatOutcome = 'disabled' | 'direct' | 'name-group';

export function newChatOutcome(picks: readonly unknown[] | null | undefined): NewChatOutcome {
  const count = picks ? picks.length : 0;
  return count === 0 ? 'disabled' : count === 1 ? 'direct' : 'name-group';
}

/** A new group's name as the dialog first offers it: the people's names in the order they were ticked. */
export function defaultGroupName(picks: readonly { name: string }[] | null | undefined): string {
  return (picks || []).map(pick => (pick.name || '').trim()).filter(Boolean).join(', ');
}
